(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class AdornyuSearch extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.input = this.querySelector('[data-search-input]');
      this.form = this.querySelector('[data-search-form]');
      this.results = this.querySelector('[data-search-results]');
      this.closeButton = this.querySelector('[data-search-close]');
      this.timer = null;
      this.controller = null;
      this.form.addEventListener('submit', (event) => { if (!this.input.value.trim()) event.preventDefault(); });
      this.input.addEventListener('input', () => this.queueSearch());
      this.closeButton.addEventListener('click', () => this.close(true));
      this.details.addEventListener('toggle', () => this.onToggle());
      document.addEventListener('click', (event) => {
        if (this.details.open && !this.contains(event.target)) this.close();
      });
      document.querySelectorAll('.adny-shop-menu').forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (menu.open) this.close();
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close(true);
      });
    }

    onToggle() {
      if (!this.details.open) return;
      document.querySelectorAll('.adny-shop-menu[open]').forEach((menu) => menu.removeAttribute('open'));
      this.input.focus();
    }

    queueSearch() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.results.hidden = true;
        this.results.replaceChildren();
        return;
      }
      this.timer = window.setTimeout(() => this.search(query), 180);
    }

    async search(query) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const parameters = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '5',
        'resources[options][unavailable_products]': 'last'
      });
      try {
        const response = await fetch(`${this.dataset.searchUrl}?${parameters}`, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Search request failed');
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        if (query === this.input.value.trim()) this.render(products);
      } catch (error) {
        if (error.name !== 'AbortError') this.render([], true);
      }
    }

    render(products, failed = false) {
      this.results.replaceChildren();
      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'adny-header-search__empty';
        empty.textContent = failed ? 'Suggestions are unavailable. Search all products below.' : 'No matching products. Try a type, color or finish.';
        this.results.append(empty);
        this.appendSearchLink();
        this.results.hidden = false;
        return;
      }
      const formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });
      products.forEach((product) => {
        const link = document.createElement('a');
        link.className = 'adny-header-search__result';
        link.href = product.url;
        if (product.featured_image?.url) {
          const image = document.createElement('img');
          image.src = product.featured_image.url;
          image.alt = product.featured_image.alt || product.title;
          image.width = 116;
          image.height = 116;
          image.loading = 'lazy';
          link.append(image);
        } else {
          link.append(document.createElement('span'));
        }
        const copy = document.createElement('span');
        const title = document.createElement('span');
        title.className = 'adny-header-search__result-title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'adny-header-search__result-price';
        price.textContent = formatter.format(Number(product.price));
        copy.append(title, price);
        link.append(copy);
        this.results.append(link);
      });
      this.appendSearchLink();
      this.results.hidden = false;
    }

    appendSearchLink() {
      const link = document.createElement('a');
      link.className = 'adny-header-search__all';
      link.href = `${this.form.action}?${new URLSearchParams({q:this.input.value.trim(),type:'product'})}`;
      link.textContent = 'View all results';
      this.results.append(link);
    }

    close(returnFocus = false) {
      this.details.open = false;
      if (returnFocus) this.querySelector('summary').focus();
    }
  }

  if (!customElements.get('adornyu-search')) customElements.define('adornyu-search', AdornyuSearch);

  } catch(e) { console.error(e); }
})();
})();
